<template>
    <div>
        <DashboardFilters
            :isAdmin="isAdmin"
            :dashboardTab="dashboardTab"
            :enableFastFilters="true"
            ref="generalFilter"
            filterFor="cards"
            @filter="onFilterChange"
            :generalFilters="true"
        ></DashboardFilters>
    </div>
</template>
<script>
import DashboardFilters from "./DashboardFilters.vue";

export default {
    components: {
        DashboardFilters,
    },
    props: {
        isAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
        dashboardTab: {
            type: String,
            required: true,
        },
    },
    methods: {
        onFilterChange() {
            this.$emit("filterChange", this.$refs.generalFilter);
        },
    },
};
</script>

